import styled from "styled-components";
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
import CreatableSelect from "react-select/creatable";

interface OTPInputProps {
  hasError?: boolean;
}

export const OTPInput = styled.input<OTPInputProps>`
  width: 50px !important;
  height: 50px;
  text-align: center;
  font-size: 20px;
  border: 1px solid var(--color-input-border);
  background-color: var(--color-bg);
  color: var(--color-text-secondary);
  border-radius: 6px;
  outline: ${({ hasError }) => (hasError ? "2px solid var(--color-invalid)" : "none")};
`;

export const CountryDropdownToggle = styled(Dropdown.Toggle)`
  width: 70px;
  height: 58px;
  margin-right: 8px;
  border-radius: 0.5rem !important;
  background-color: transparent;
  border: 1px solid #ced4da;
  color: var(--color-text-secondary);
  border-color: var(--color-input-border);
  text-align: center;
  box-shadow: none;

  &:focus,
  &:active,
  &:hover,
  &.show {
    box-shadow: none;
    background-color: transparent;
    border-color: var(--color-input-border);
    color: var(--color-text-secondary);
  }
`;

export const CountryDropdownItem = styled(Dropdown.Item)`
  color: var(--color-text-secondary);
  background-color: var(--color-bg);
  border-color: var(--color-input-border);

  &:hover,
  &:focus {
    background-color: var(--color-primary);
    color: var(--color-text-primary);
    border-color: var(--color-input-border);
  }

  &.active,
  &:active {
    background-color: var(--color-primary);
    color: var(--color-text-primary);
    font-weight: 500;
    border-color: var(--color-input-border);
  }
`;

export const CountryDropdownMenu = styled(Dropdown.Menu)`
  min-width: 220px;
  background-color: var(--color-bg);
  border-color: var(--color-input-border);
`;

export const PhoneInput = styled(Form.Control)`
  height: 58px;
  border-radius: 0.5rem !important;
  border: 1px solid var(--color-input-border);
  background-color: var(--color-bg);
  color: var(--color-text-secondary);

  &:focus {
    box-shadow: none;
    border-color: var(--color-border);
  }

  &::placeholder {
    color: var(--color-text-secondary);
    opacity: 0.6;
  }
`;

export const Divider = styled.hr`
  border: none;
  height: 4px;
  background-color: var(--color-text-primary);
  margin: 24px 0;
`;

export const StyledCreatableSelect = styled(CreatableSelect)`
  .react-select__control {
    background-color: var(--color-bg);
    border-color: var(--color-input-border);
    border-radius: 6px;
    min-height: 58px;
    box-shadow: none;

    &:hover {
      border-color: var(--color-input-border);
    }
  }

  .react-select__value-container {
    padding: 13px 12px 0 12px;
  }

  .react-select__input {
    color: var(--color-text-secondary);
    margin: 0;
    padding: 0;
  }

  .react-select__single-value {
    color: var(--color-text-secondary);
    margin-left: 0;
  }

  .react-select__menu {
    background-color: var(--color-card-bg);
    border: 1px solid var(--color-input-border);
    z-index: 9999;
  }

  .react-select__option {
    color: var(--color-text-primary);

    &--is-focused {
      background-color: var(--color-containers-bg);
    }

    &--is-selected {
      background-color: var(--color-primary);
      color: var(--color-text-active);
    }

    &:active {
      background-color: var(--color-primary);
    }
  }

  .react-select__placeholder {
    display: none; /* necesario para FloatingLabel */
  }

  .react-select__indicator-separator {
    display: none;
  }

  .react-select__dropdown-indicator {
    color: var(--color-text-secondary);

    &:hover {
      color: var(--color-text-primary);
    }
  }
`;
